// import React from 'react';
// import Spacing from '../componenets/UI/Spacing';
// import { useTranslation } from 'react-i18next';
// import { Helmet } from 'react-helmet';
// import SecurityMineralIcon from '../../src/componenets/icons/SecurityMineralIcon';
// import IndustrialMineralsIcon from '../../src/componenets/icons/IndustrialMineralsIcon';

// export default function FutureMineralsSecurityPage() {
//   const { t } = useTranslation();
//   const isRTL = t.language === 'ar';
//   return (
//     <>
//       <Helmet>
//         <title>{`APFM | ${t('INDUSTRIES')}`}</title>
//       </Helmet>

//       <Spacing />

//       <div className="app-container px-8 lg:px-0">
//         <h2
//           data-aos="fade-down"
//           data-aos-delay={100}
//           className="mb-4 text-2xl font-black"
//         >
//           {t('AGRICULTURAL_APPLICATIONS')}
//         </h2>

//         <div className="grid grid-cols-8 gap-4">
//           {t('SECURITY_LIST', { returnObjects: true }).map((industria, i) => {
//             const rows = [
//               [industria.TD_SECURITY1, industria.TH_INDUSTRIEL1],
//               [industria.TD_SECURITY2, industria.TH_INDUSTRIEL2],
//               [industria.TD_SECURITY3, industria.TH_INDUSTRIEL3],
//               [industria.TD_SECURITY4, industria.TH_INDUSTRIEL4],
//               [industria.TD_SECURITY5, industria.TH_INDUSTRIEL5],
//               [industria.TD_SECURITY6, industria.TH_INDUSTRIEL6],
//               [industria.TD_SECURITY7, industria.TH_INDUSTRIEL7],
//               [industria.TD_SECURITY8, industria.TH_INDUSTRIEL8],
//               [industria.TD_SECURITY9, industria.TH_INDUSTRIEL9],
//             ].filter(([sec, ind]) => sec || ind);

//             return (
//               <div
//                 key={i}
//                 data-aos="fade-up"
//                 data-aos-delay={100}
//                 className="relative col-span-12 min-h-[320px] border-2 border-muted-300 bg-light p-4 lg:col-span-4"
//               >
//                 <h1 className="text-2xl font-bold">{industria.TITLE}</h1>

//                 <div className="p-2">{industria.DESCRIPTION}</div>

//                 <h2 className="mt-2 pb-6 font-bold text-info">{industria.SUB_TITLE}</h2>

//                 <table className="table-auto border border-gray-300 rounded-lg overflow-hidden shadow-md text-right">
//                   <thead className="bg-primary-600 text-white">
//                     <tr>
//                       <th className="p-4 text-right">
//                         <div className="flex items-center gap-2">
//                           {industria.TH_SECURITY && (
//                             <SecurityMineralIcon size={22} color="#fff" />
//                           )}
//                           {industria.TH_SECURITY}
//                         </div>
//                       </th>
//                       <th className="p-4 text-right">
//                         <div className="flex items-center justify-end gap-2">
//                           {industria.TH_INDUSTRIEL && (
//                             <IndustrialMineralsIcon size={22} color="#fff" />
//                           )}
//                           {industria.TH_INDUSTRIEL}
//                         </div>
//                       </th>
//                     </tr>

//                   </thead>
//                   <tbody dir={isRTL ? 'rtl' : 'ltr'}>
//                     {rows.map(([security, industrial], index) => (
//                       <tr key={index} className="bg-white transition hover:bg-gray-50">
//                         <td className={`p-4 text-gray-700 ${isRTL ? 'text-right' : 'text-left'}`}>
//                           {security}
//                         </td>
//                         <td className={`p-4 text-gray-700 ${isRTL ? 'text-right' : 'text-left'}`}>
//                           {industrial}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>

//                 </table>

//                 <div className="mt-4 flex justify-end">
//                   <img
//                     className={`absolute bottom-2 h-40 w-auto object-contain ${isRTL ? 'start' : 'end'
//                       }`}
//                     src={industria.ICON}
//                     alt=""
//                   />
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </>
//   );
// }









// import React from 'react';
// import Spacing from '../componenets/UI/Spacing';
// import { useTranslation } from 'react-i18next';
// import { Helmet } from 'react-helmet';
// import IndustrialMineralsIcon from '../../src/componenets/icons/IndustrialMineralsIcon';

// export default function FutureMineralsSecurityPage() {
//   const { t } = useTranslation();
//   const isRTL = t.language === 'ar';


//   const splitIntoColumns = (arr, size) => {
//     const columns = [];
//     for (let i = 0; i < arr.length; i += size) {
//       columns.push(arr.slice(i, i + size));
//     }
//     return columns;
//   };


//   const renderCellContent = (values) => {
//     const columns = [];
//     for (let i = 0; i < values.length; i += 5) {
//       columns.push(values.slice(i, i + 5));
//     }

//     return (
//       <div className="flex gap-4 flex-wrap">
//         {columns.map((col, idx) => (
//           <div key={idx} className="flex flex-col gap-1 min-w-[120px]">
//             {col.map((item, subIdx) => (
//               <div key={subIdx} className="whitespace-nowrap">{item}</div>
//             ))}
//           </div>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <>
//       <Helmet>
//         <title>{`APFM | ${t('INDUSTRIES')}`}</title>
//       </Helmet>

//       <Spacing />

//       <div className="app-container px-8 lg:px-0">
//         <h2 data-aos="fade-down" data-aos-delay={100} className="mb-4 text-2xl font-black">
//           {t('AGRICULTURAL_APPLICATIONS')}
//         </h2>

//         <div className="grid grid-cols-8 gap-4">
//           {t('SECURITY_LIST', { returnObjects: true }).map((industria, i) => {
//             const securityValues = Object.entries(industria)
//               .filter(([key, val]) => key.startsWith("TD_SECURITY") && val)
//               .map(([_, val]) => val);

//             const industrialValues = Object.entries(industria)
//               .filter(([key, val]) => key.startsWith("TH_INDUSTRIEL") && val)
//               .map(([_, val]) => val);

//             return (
//               <div
//                 key={i}
//                 data-aos="fade-up"
//                 data-aos-delay={100}
//                 className="relative col-span-12 min-h-[320px] border-2 border-muted-300 bg-light p-4 lg:col-span-4 pb-32"
//               >
//                 <h1 className="text-2xl font-bold">{industria.TITLE}</h1>

//                 <div className="p-2 text-justify">{industria.DESCRIPTION}</div>

//                 <h2 className="mt-2 pb-6 font-bold text-info">{industria.SUB_TITLE}</h2>

//                 {/* <table className="table-auto border border-gray-300 rounded-lg overflow-hidden shadow-md text-right">
//                   <thead className="bg-primary-600 text-white">
//                     <tr>
//                       <th className="p-4">
//                         <div className="flex items-center justify-center gap-2">
//                           {industria.TH_SECURITY && (
//                             <SecurityMineralIcon size={22} color="#fff" />
//                           )}
//                           {industria.TH_SECURITY}
//                         </div>
//                       </th>
//                       <th className="p-4">
//                         <div className="flex items-center justify-center gap-2">
//                           {industria.TH_INDUSTRIEL && (
//                             <IndustrialMineralsIcon size={22} color="#fff" />
//                           )}
//                           {industria.TH_INDUSTRIEL}
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody dir={isRTL ? 'rtl' : 'ltr'}>
//                     <tr >
//                       <td className={`p-4 m-0 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                         {renderCellContent(securityValues)}
//                       </td>
//                       <td className={`p-4 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                         {renderCellContent(industrialValues)}
//                       </td>
//                     </tr>
//                   </tbody>
//                 </table> */}

//                 {/* <div className="w-full overflow-x-auto">
//                   <table className="table-auto bottom-1 border border-gray-300 rounded-lg overflow-hidden shadow-md text-right mt-4 w-full">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && (
//                           <th className="bg-security text-white border border-gray-400 px-6 py-4 text-center whitespace-nowrap">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <th className="bg-industrial text-white border border-gray-400 px-6 py-4 text-center whitespace-nowrap">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && (
//                           <td className={`border border-gray-300 px-6 py-4 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                             <div className="flex flex-wrap justify-center gap-2">
//                               {renderCellContent(securityValues)}
//                             </div>
//                           </td>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <td className={`border border-gray-300 px-6 py-4 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                             <div className="flex flex-wrap justify-center gap-2">
//                               {renderCellContent(industrialValues)}
//                             </div>
//                           </td>
//                         )}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div> */}


//                 {/* <div className="w-full overflow-x-auto">
//                   <table className="table-auto border border-gray-300 rounded-lg overflow-hidden text-right mt-4 w-full">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && !industria.TH_INDUSTRIEL && (
//                           <th className="px-6 py-4 text-center whitespace-nowrap">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && !industria.TH_SECURITY && (
//                           <th className="px-6 py-4 text-center whitespace-nowrap">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody className="divide-y divide-gray-400">
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && !industria.TH_INDUSTRIEL && (
//                           // Séparation verticale pour chaque valeur
//                           <td className={`px-6 py-4 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                             <div className={`flex ${isRTL ? 'flex-row-reverse' : 'flex-row'} justify-center`}>
//                               {splitIntoColumns(securityValues, 5).map((col, colIdx) => (
//                                 <div
//                                   key={colIdx}
//                                   className={`flex flex-col px-3 ${colIdx !== 0 ? (isRTL ? 'border-l-4' : 'border-r-4') : ''
//                                     } border-gray-300`}
//                                 >
//                                   {col.map((item, idx) => (
//                                     <div key={idx} className="py-1 whitespace-nowrap">
//                                       {item}
//                                     </div>
//                                   ))}
//                                 </div>
//                               ))}
//                             </div>
//                           </td>
//                         )}

//                         {industria.TH_INDUSTRIEL && !industria.TH_SECURITY && (
//                           <td className={`px-6 py-4 align-top ${isRTL ? 'text-right' : 'text-center'}`}>
//                             <div className={`flex ${isRTL ? 'flex-row-reverse' : ''} justify-center items-start`}>
//                               {splitIntoColumns(industrialValues, 5).map((col, colIdx) => (
//                                 <div
//                                   key={colIdx}
//                                   className={`flex flex-col px-3 ${colIdx !== 0 ? (isRTL ? 'border-l-4' : 'border-r-4') : ''} border-gray-300`}
//                                 >
//                                   {col.map((item, idx) => (
//                                     <div key={idx} className="py-1 whitespace-nowrap">
//                                       {item}
//                                     </div>
//                                   ))}
//                                 </div>
//                               ))}
//                             </div>
//                           </td>
//                         )}

//                       </tr>
//                     </tbody>
//                   </table> 
//                 </div> */}

//                 {/* <div className="w-full overflow-x-auto">
//                   <table className="min-w-full border border-gray-300 rounded-lg overflow-hidden shadow-md mt-4">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && (
//                           <th className="bg-security text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <th className="bg-industrial text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <ul className="list-disc list-inside space-y-1">
//                               {securityValues.map((item, index) => (
//                                 <li key={index}>{item}</li>
//                               ))}
//                             </ul>
//                           </td>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <ul className="list-disc list-inside space-y-1">
//                               {industrialValues.map((item, index) => (
//                                 <li key={index}>{item}</li>
//                               ))}
//                             </ul>
//                           </td>
//                         )}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div> */}



//                 <div className="w-full overflow-x-auto">
//                   <table className="min-w-full rounded-t-lg overflow-hidden mt-4">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && (
//                           <th className="bg-security text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <th className="bg-industrial text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <div className={`${securityValues.length > 2 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(securityValues.length > 2
//                                 ? [securityValues.slice(0, Math.ceil(securityValues.length / 2)), securityValues.slice(Math.ceil(securityValues.length / 2))]
//                                 : [securityValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}

//                         {industria.TH_INDUSTRIEL && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <div className={`${industrialValues.length > 5 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(industrialValues.length > 5
//                                 ? [industrialValues.slice(0, Math.ceil(industrialValues.length / 2)), industrialValues.slice(Math.ceil(industrialValues.length / 2))]
//                                 : [industrialValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>



//                 {/* <div className="w-full overflow-x-auto">
//                   <table className="min-w-full overflow-hidden  rounded-t-lg mt-4 border-gray-300">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && (
//                           <th className="bg-security text-white border-l border-r border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <th className="bg-industrial text-white border-l border-r border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && (
//                           <td className="border-l border-r border-gray-300 px-4 py-3 align-top ">
//                             <div className={`${securityValues.length > 2 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(securityValues.length > 2
//                                 ? [securityValues.slice(0, Math.ceil(securityValues.length / 2)), securityValues.slice(Math.ceil(securityValues.length / 2))]
//                                 : [securityValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}

//                         {industria.TH_INDUSTRIEL && (
//                           <td className="border-l border-r border-gray-300 px-4 py-3 align-top">
//                             <div className={`${industrialValues.length > 5 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(industrialValues.length > 5
//                                 ? [industrialValues.slice(0, Math.ceil(industrialValues.length / 2)), industrialValues.slice(Math.ceil(industrialValues.length / 2))]
//                                 : [industrialValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div> */}


//                 <div className={`mt-12 flex ${isRTL ? 'justify-start' : 'justify-end'}`}>
//                   <img
//                     className="absolute bottom-1 h-40 w-auto object-contain"
//                     src={industria.ICON}
//                     alt=""
//                   />
//                 </div>

//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </>
//   );
// }














// import React from 'react';
// import Spacing from '../componenets/UI/Spacing';
// import { useTranslation } from 'react-i18next';
// import { Helmet } from 'react-helmet';
// import IndustrialMineralsIcon from '../../src/componenets/icons/IndustrialMineralsIcon';

// export default function FutureMineralsSecurityPage() {
//   const { t } = useTranslation();
//   const isRTL = t.language === 'ar';




//   return (
//     <>
//       <Helmet>
//         <title>{`APFM | ${t('INDUSTRIES')}`}</title>
//       </Helmet>

//       <Spacing />

//       <div className="app-container px-8 lg:px-0">
//         <h2 data-aos="fade-down" data-aos-delay={100} className="mb-4 text-2xl font-black">
//           {t('AGRICULTURAL_APPLICATIONS')}
//         </h2>

//         <div className="grid grid-cols-8 gap-4">
//           {t('SECURITY_LIST', { returnObjects: true }).map((industria, i) => {
//             const securityValues = Object.entries(industria)
//               .filter(([key, val]) => key.startsWith("TD_SECURITY") && val)
//               .map(([_, val]) => val);

//             const industrialValues = Object.entries(industria)
//               .filter(([key, val]) => key.startsWith("TH_INDUSTRIEL") && val)
//               .map(([_, val]) => val);

//             return (

//               <div
//                 key={i}
//                 data-aos="fade-up"
//                 data-aos-delay={100}
//                 className="relative col-span-12 min-h-[320px] border-2 border-muted-300 bg-light p-4 lg:col-span-4"
//               >
//                 <h1 className="text-2xl font-bold">{industria.TITLE}</h1>

//                 <div className={`flex items-start gap-4 ${isRTL ? 'flex-row-reverse' : ''}`}>
//                   <div className="mt-4 flex-1 text-justify">
//                     {industria.DESCRIPTION}
//                   </div>

//                   <div className="shrink-0">
//                     <img
//                       className="h-40 w-auto object-contain"
//                       src={industria.ICON}
//                       alt=""
//                     />
//                   </div>
//                 </div>

//                 <h2 className="mt-4 font-bold text-info">{industria.SUB_TITLE}</h2>

//                 <div className="w-full overflow-x-auto">
//                   <table className="min-w-full rounded-t-lg overflow-hidden mt-4">
//                     <thead className="bg-primary-600 text-white">
//                       <tr>
//                         {industria.TH_SECURITY && (
//                           <th className="bg-security text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <img
//                                 src="/assets/icons/security-color-header/security-food-icon.svg"
//                                 alt=""
//                                 className="h-5 w-5"
//                               />
//                               {industria.TH_SECURITY}
//                             </div>
//                           </th>
//                         )}
//                         {industria.TH_INDUSTRIEL && (
//                           <th className="bg-industrial text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
//                             <div className="flex items-center justify-center gap-2">
//                               <IndustrialMineralsIcon size={20} color="#fff" />
//                               {industria.TH_INDUSTRIEL}
//                             </div>
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">
//                         {industria.TH_SECURITY && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <div className={`${securityValues.length > 2 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(securityValues.length > 2
//                                 ? [securityValues.slice(0, Math.ceil(securityValues.length / 2)), securityValues.slice(Math.ceil(securityValues.length / 2))]
//                                 : [securityValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}

//                         {industria.TD_INDUSTRIEL && (
//                           <td className="border border-gray-300 px-4 py-3 align-top">
//                             <div className={`${industrialValues.length > 5 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
//                               {(industrialValues.length > 5
//                                 ? [industrialValues.slice(0, Math.ceil(industrialValues.length / 2)), industrialValues.slice(Math.ceil(industrialValues.length / 2))]
//                                 : [industrialValues]
//                               ).map((columnItems, colIndex) => (
//                                 <ul key={colIndex} className="list-disc list-inside space-y-1">
//                                   {columnItems.map((item, index) => (
//                                     <li key={index}>{item}</li>
//                                   ))}
//                                 </ul>
//                               ))}
//                             </div>
//                           </td>
//                         )}
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>

//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </>
//   );
// }





import React from 'react';
import Spacing from '../componenets/UI/Spacing';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import IndustrialMineralsIcon from '../../src/componenets/icons/IndustrialMineralsIcon';

export default function FutureMineralsSecurityPage() {
  const { t } = useTranslation();
  const isRTL = t.language === 'ar';

  return (
    <>
      <Helmet>
        <title>{`APFM | ${t('INDUSTRIES')}`}</title>
      </Helmet>

      <Spacing />

      <div className="app-container px-8 lg:px-0">
        <h2 data-aos="fade-down" data-aos-delay={100} className="mb-4 text-2xl font-black">
          {t('AGRICULTURAL_APPLICATIONS')}
        </h2>

        <div className="grid grid-cols-8 gap-4">
          {t('SECURITY_LIST', { returnObjects: true }).map((industria, i) => {

            // ✅ استخراج قيم الأمن الغذائي
            const securityValues = Object.entries(industria)
              .filter(([key, val]) => key.startsWith("TD_SECURITY") && val)
              .map(([_, val]) => val);

            // ✅ استخراج قيم المعادن الصناعية
            const industrielTDValues = Object.entries(industria)
              .filter(([key, val]) => key.startsWith("TD_INDUSTRIEL") && val)
              .map(([_, val]) => val);

            return (
              <div
                key={i}
                data-aos="fade-up"
                data-aos-delay={100}
                className="relative col-span-12 min-h-[320px] border-2 border-muted-300 bg-light p-4 lg:col-span-4"
              >
                <h1 className="text-2xl font-bold">{industria.TITLE}</h1>

                <div className={`flex items-start gap-4 mt-4 ${isRTL ? 'flex-row-reverse' : ''}`}>
                  <div className="mt-4 flex-1 text-justify">
                    {industria.DESCRIPTION}
                    </div>
                  <div className="shrink-0">
                    <img
                      className="h-40 w-auto object-contain"
                      src={industria.ICON}
                      alt=""
                    />
                  </div>                
                </div>

                <h2 className="mt-4 font-bold text-info">{industria.SUB_TITLE}</h2>

                <div className="w-full overflow-x-auto mt-6 border">
                  <table className="min-w-full rounded-t-lg overflow-hidden">
                    <thead className="bg-primary-600 text-white">
                      <tr>

                        {/* ✅ عنوان عمود الأمن الغذائي */}
                        {industria.TH_SECURITY && (
                          <th className="bg-security text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
                            <div className="flex items-center justify-center gap-2">
                              <img
                                src="/assets/icons/security-color-header/security-food-icon.svg"
                                alt=""
                                className="h-5 w-5"
                              />
                              {industria.TH_SECURITY}
                            </div>
                          </th>
                        )}

                        {/* ✅ عنوان عمود المعادن الصناعية */}
                        {industria.TH_INDUSTRIEL && (
                          <th className="bg-industrial text-white border border-gray-400 px-4 py-3 text-center whitespace-nowrap text-sm">
                            <div className="flex items-center justify-center gap-2">
                              <IndustrialMineralsIcon size={20} color="#fff" />
                              {industria.TH_INDUSTRIEL}
                            </div>
                          </th>
                        )}

                      </tr>
                    </thead>

                    <tbody>
                      <tr className="hover:bg-gray-50 transition duration-150 ease-in-out">

                        {/* ✅ عرض لائحة الأمن الغذائي */}
                        {securityValues.length > 0 && (
                          <td className="border border-gray-300 px-4 py-3 align-top">
                            <div className={`${securityValues.length > 2 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
                              {(securityValues.length > 2
                                ? [
                                    securityValues.slice(0, Math.ceil(securityValues.length / 2)),
                                    securityValues.slice(Math.ceil(securityValues.length / 2))
                                  ]
                                : [securityValues]
                              ).map((columnItems, colIndex) => (
                                <ul key={colIndex} className="list-disc list-inside space-y-1">
                                  {columnItems.map((item, index) => <li key={index}>{item}</li>)}
                                </ul>
                              ))}
                            </div>
                          </td>
                        )}

                        {/* ✅ عرض لائحة المعادن الصناعية */}
                        {industrielTDValues.length > 0 && (
                          <td className="border border-gray-300 px-4 py-3 align-top">
                            <div className={`${industrielTDValues.length > 5 ? 'grid grid-cols-2 gap-x-4' : ''}`}>
                              {(industrielTDValues.length > 5
                                ? [
                                    industrielTDValues.slice(0, Math.ceil(industrielTDValues.length / 2)),
                                    industrielTDValues.slice(Math.ceil(industrielTDValues.length / 2))
                                  ]
                                : [industrielTDValues]
                              ).map((columnItems, colIndex) => (
                                <ul key={colIndex} className="list-disc list-inside space-y-1">
                                  {columnItems.map((item, index) => <li key={index}>{item}</li>)}
                                </ul>
                              ))}
                            </div>
                          </td>
                        )}

                      </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}











